<template>
  <div class="app">
    <!-- <Layout
      :resize="resize"
      :splits="splits">
      <bd-aside class="custom-drag"></bd-aside>
      <bd-main class="custom-drag"></bd-main>
    </Layout> -->
    <splitpanes class="default-theme">
      <pane size="22">
        <bd-aside></bd-aside>
      </pane>
      <pane size="43">
        <splitpanes horizontal>
          <pane size="6" min-size="6">
            <bd-top></bd-top>
          </pane>
          <pane size="94">
            <bd-message></bd-message>
          </pane>
        </splitpanes>
      </pane>
      <pane size="35">
        <bd-right></bd-right>
      </pane>
    </splitpanes>
  </div>
</template>

<script>
// https://antoniandre.github.io/splitpanes/
import { Splitpanes, Pane } from 'splitpanes'
import 'splitpanes/dist/splitpanes.css'
// import { Layout } from 'vue-split-layout'
import BdAside from '@/components/dashboard/main/block/BdAside'
// import BdMain from '@/components/dashboard/main/block/BdMain'
import BdTop from '@/components/dashboard/main/block/children/BdTop'
import BdMessage from '@/components/dashboard/main/block/children/BdMessage'
// import BdInput from '@/components/dashboard/main/block/children/BdInput'
import BdRight from '@/components/dashboard/main/block/children/BdRight'

export default {
  name: 'bd-online',
  // components: { BdAside, BdMain, Layout },
  components: { BdAside, BdTop, BdMessage, BdRight, Splitpanes, Pane },
  data () {
    return {
      resize: true,
      splits: {
        dir: 'horizontal',
        first: 0,
        second: 1,
        split: '20%'
      }
    }
  }
}
</script>

<style scope>
</style>
